import React from 'react';
import { FaInstagram, FaLinkedin, FaGithub } from 'react-icons/fa';
import links from '../data/links.json';
import '../style/socialIcons.css';

const SocialIcons = () => {
   return (
      <div className="social-icons">
         <a href={links["instagram-link"]} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
         </a>
         <a href={links["linkedin-link"]} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <FaLinkedin />
         </a>
         <a href={links["github-link"]} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
            <FaGithub />
         </a>
      </div>
   );
};

export default SocialIcons;